import React from 'react'

import Offer from '../mam3/Offer'

import { useSuperscript } from "../../utils/SuperscriptHelper";
import { FootnotesFromContext } from "../../subcomponents/Footnotes";

const TeaserAction = props => {
    const campaignWithSuperscript = {
        ...props.campaign,
        flagstoerer: useSuperscript(props.campaign.flagstoerer, true),
        title_3_long: useSuperscript(props.campaign.title_3_long, true),
        main_benefit_components_web: useSuperscript(props.campaign.main_benefit_components, true),
    }

    return(
        <div>
            <Offer className="teaser-action banner"
                   isCcMedien={true}
                   image={props.campaign.image_16_9} {...props}
                   campaign={campaignWithSuperscript} />
            <FootnotesFromContext
                showWarningText={props.footnotesWarningText}
                bigIndices={props.bigIndices}
            />
        </div>
    )
}

export default TeaserAction



// WEBPACK FOOTER //
// ./src/components/ads/creditcard/TeaserAction.js